// Physical grid extents + resolution for the currently-loaded HDF5 dataset.
// Distinct from physics/types.PhysicsGrid (capital-cased here, owned by the
// viewer). The capitalised shape is what scene/grid + scene/slices expect.

import { SCENE_DEFAULTS } from '../../config/defaults';

export interface AxisRange { min: number; max: number }

export interface AxisExtents {
    x: AxisRange;
    y: AxisRange;
    z: AxisRange;
}

export interface GridState {
    xMin: number; xMax: number;
    yMin: number; yMax: number;
    zMin: number; zMax: number;
    nx: number; ny: number; nz: number;
    resolutionX: number; resolutionY: number; resolutionZ: number;
    axisExtents: AxisExtents | null;
    gridSpacing: number | null;
    minorSpacing: number | null;
    majorSpacing: number | null;
}

export function createGridState(): GridState {
    return {
        xMin: 0, xMax: 0,
        yMin: 0, yMax: 0,
        zMin: 0, zMax: 0,
        nx: 0, ny: 0, nz: 0,
        resolutionX: 0, resolutionY: 0, resolutionZ: 0,
        axisExtents: { ...SCENE_DEFAULTS.axisExtents },
        gridSpacing: SCENE_DEFAULTS.gridSpacing,
        minorSpacing: SCENE_DEFAULTS.minorSpacing,
        majorSpacing: SCENE_DEFAULTS.majorSpacing,
    };
}
